import React from "react";
import { ShieldCheck, Mail } from "lucide-react";
import { Container, PageHero, Reveal } from "../components/shared/Shared";
import { useLang } from "../context/LanguageContext";
import { PRIVACY, COOKIE_UI } from "../data/privacy";

export const Privacy = () => {
  const { lang, c } = useLang();
  const p = PRIVACY[lang];
  const cu = COOKIE_UI[lang];
  return (
    <>
      <PageHero title={p.title} subtitle={p.subtitle} crumbs={[{ label: cu.privacy }]} image={c.IMAGES.datacenter} />
      <section className="py-20" data-testid="privacy-page">
        <Container className="grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-8">
            <Reveal className="flex items-center gap-3 text-sm text-slate-500"><ShieldCheck className="h-5 w-5 text-brand-teal" />{p.updated}</Reveal>
            <div className="mt-8 space-y-10">
              {p.sections.map((s, i) => (
                <Reveal key={s.h} delay={Math.min(i, 4) * 60} as="article" data-testid="privacy-section">
                  <h2 className="font-heading text-2xl font-bold text-brand-navy">{s.h}</h2>
                  {s.p.map((para) => <p key={para.slice(0, 30)} className="mt-3 leading-relaxed text-slate-600">{para}</p>)}
                </Reveal>
              ))}
            </div>
          </div>
          <aside className="lg:col-span-4">
            <div className="rounded-2xl border border-slate-200 bg-slate-50 p-6 lg:sticky lg:top-32">
              <p className="text-xs font-bold uppercase tracking-[0.2em] text-brand-orange">{cu.privacy}</p>
              <ul className="mt-4 space-y-2 text-sm">
                {p.sections.map((s) => <li key={s.h} className="text-slate-600">{s.h}</li>)}
              </ul>
              <div className="mt-6 border-t border-slate-200 pt-5">
                <a href={`mailto:${c.COMPANY.email}`} className="inline-flex items-center gap-2 text-sm font-semibold text-brand-teal hover:text-brand-teal-dark"><Mail className="h-4 w-4" />{c.COMPANY.email}</a>
                <button type="button" onClick={() => window.dispatchEvent(new Event("open-cookie-settings"))} className="btn-outline mt-4 h-10 w-full text-sm" data-testid="open-cookie-settings">{cu.manage}</button>
              </div>
            </div>
          </aside>
        </Container>
      </section>
    </>
  );
};
